import React from 'react';
import styled from 'styled-components';
import CSLTable from '../Common/MCCTable';
import { FaPencilAlt,FaEdit, FaTimes,FaPlusCircle, FaEllipsisV } from "react-icons/fa";
import { IoIosCheckboxOutline, IoIosSquareOutline, IoIosWarning } from "react-icons/io";
import ReasonForBreachConfigModal from './ReasonForBreachConfigModal';
import Store from '../../Common/Store'
import AlertBox from '../Common/AlertBox';
import Toggle from 'react-toggle';
import "./ReactToggle.css";
import VerticalEllipsisMenuFolderReasonBreach from "./VerticalEllipsisMenuFolderReasonBreach";
import CSLLoader from './../Common/CSLLoader';


const SearchInput = styled.input`
    height: 30px;
    width: 98%;
    border: 1px solid #ffffff;
    border-radius: 3px;
    box-shadow: 0 0 4px #c4c4c4;
    padding: 5px;
    color: #222222;
    font-size: 15px;
    font-family: 'Montserrat', sans-serif;
`;
const MRButton = styled.button`
    box-sizing: border-box;
    background-color: #1E3E62;
    color: #ffffff;
    border: 1px solid #1E3E62;
    width: 37%;
    font-size: 13px;
    height: 43px;
    border-radius: 4px;
    display: inline-block;
    margin-left: 5px;
`;
const MRModalLabel = styled.div`
    color: #212121;
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 10px;
    display: inline-block;
`;
const ExportButton = styled.button`
    box-sizing: border-box;
    background-color: #213E61;
    color: #F2F2F2;
    border: 1px solid #213E61;
    width: 125px;
    font-size: 14px;
    height: 32px;
    border-radius: 5px;
    margin-right: 3px;
    margin-top: 19px;
`;

const EmailContainer = styled.div`
	width: 100%;
`;
const EmailInnerContainer = styled.div`
	background-color: #ffffff;
	padding: 30px;
`;
const EmailBoldLabel = styled.div`
	font-weight: 600;
	color: #595959;
	margin-top: 5px;
`;
const EmailTopHeader = styled.div`
	font-weight: 600;
	color: #595959;
	margin-top: 5px;
	width:100%;
	height: 58px;
	padding: 20px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
  box-sizing: border-box;	
`;
const InactiveOverlay = styled.div`
  display: block;
  box-sizing: border-box;
  height: 210%;
  width: 100%;
  background-color: #ffffff;
  position: absolute;
  left: 0%;
  top: -46px;
  z-index: 1000;
  opacity: 0.8;
`;


class ReasonForBreach extends React.Component
{
    state = {
        showActiveCheckbox: false,
        reason_for_breach: null,
        show_reason_for_breach_array: null,
        reason_for_breach_search: null,
        reasonforBreachActiveArrayAll: null,
        reasonforBreachInactiveArrayAll: null,
        ready: false,
        show_reason_for_breach_modal: false,
        standard_reason_for_breach: null,
        curid: 0,
        content: null,
        alert_param: null,
        headerText: '',
        isLoadedIcon: false
    };
    constructor(props) {
        super(props);        
    }

    componentDidMount()
	{		
		let reasonforBreachActiveArrayAll = [];		
		let reasonforBreachInactiveArrayAll = [];
		for(let i=0;i<this.props.reason_for_Breach.length;i++){
			if(this.props.reason_for_Breach[i].isActive === 1){
                reasonforBreachActiveArrayAll.push(this.props.reason_for_Breach[i])
                reasonforBreachInactiveArrayAll.push(this.props.reason_for_Breach[i])
			}else{
				reasonforBreachInactiveArrayAll.push(this.props.reason_for_Breach[i])
			}
		}
		let reasonforbreachValue = [];
		if(this.props.general.reason_breach_active_inactive){
			reasonforbreachValue = reasonforBreachInactiveArrayAll
			console.log("Sourav")
		}else{			
			reasonforbreachValue = reasonforBreachActiveArrayAll
			console.log("Sourav1")
		}

        let reason_for_Breach_object = {};
        for(let d of this.props.reason_for_Breach){
            reason_for_Breach_object[d.reasonforBreachID] = d
        }
        let reason_for_Breach_array = [];
        for(let k in reason_for_Breach_object){
            reason_for_Breach_array.push(reason_for_Breach_object[k])
        }
        console.log("reason_for_Breach_array===>",reason_for_Breach_array);

		this.setState({showActiveCheckbox: this.props.general.reason_breach_active_inactive,
			// reason_for_breach: this.props.reason_for_Breach,
			reason_for_breach: reason_for_Breach_array,
			//show_reason_for_breach_array: reasonforbreachValue,
			// show_reason_for_breach_array: this.props.reason_for_Breach,
			show_reason_for_breach_array: reason_for_Breach_array,
			// reason_for_breach_search: this.props.reason_for_Breach,
			reason_for_breach_search: reason_for_Breach_array,
			reasonforBreachActiveArrayAll: reasonforBreachActiveArrayAll,
            reasonforBreachInactiveArrayAll: reasonforBreachInactiveArrayAll,
            standard_reason_for_breach: this.props.standard_reason_for_breach,
            ready: true, alert_param: null});
		console.log("reason_for_Breach===>",this.props.reason_for_Breach);
    }
    
    componentDidUpdate(prevProps)
	{
		if (prevProps !== this.props) {
			let reasonforBreachActiveArrayAll = [];		
            let reasonforBreachInactiveArrayAll = [];
            for(let i=0;i<this.props.reason_for_Breach.length;i++){
                if(this.props.reason_for_Breach[i].isActive === 1){
                    reasonforBreachActiveArrayAll.push(this.props.reason_for_Breach[i])
                    reasonforBreachInactiveArrayAll.push(this.props.reason_for_Breach[i])
                }else{
                    reasonforBreachInactiveArrayAll.push(this.props.reason_for_Breach[i])
                }
            }
            let reasonforbreachValue = [];
            if(this.props.general.reason_breach_active_inactive){
                reasonforbreachValue = reasonforBreachInactiveArrayAll
                console.log("Sourav")
            }else{			
                reasonforbreachValue = reasonforBreachActiveArrayAll
                console.log("Sourav1")
            }

            let reason_for_Breach_object = {};
            for(let d of this.props.reason_for_Breach){
                reason_for_Breach_object[d.reasonforBreachID] = d
            }
            let reason_for_Breach_array = [];
            for(let k in reason_for_Breach_object){
                reason_for_Breach_array.push(reason_for_Breach_object[k])
            }
            console.log("reason_for_Breach_array===>",reason_for_Breach_array);

            this.setState({showActiveCheckbox: this.props.general.reason_breach_active_inactive,
                // reason_for_breach: this.props.reason_for_Breach,
                reason_for_breach: reason_for_Breach_array,
                //show_reason_for_breach_array: reasonforbreachValue,
                // show_reason_for_breach_array: this.props.reason_for_Breach,
                show_reason_for_breach_array: reason_for_Breach_array,
                // reason_for_breach_search: this.props.reason_for_Breach,
                reason_for_breach_search: reason_for_Breach_array,
                reasonforBreachActiveArrayAll: reasonforBreachActiveArrayAll,
                reasonforBreachInactiveArrayAll: reasonforBreachInactiveArrayAll,
                standard_reason_for_breach: this.props.standard_reason_for_breach,
                ready: true, alert_param: null,
                isLoadedIcon: false});
            console.log("reason_for_Breach===>",this.props.reason_for_Breach);			
		}
    }
    
    searchValue = (event) => {
		event.preventDefault();
        console.log("Sourav",event.target.value);
		console.log("fddsf",this.state.reason_for_breach_search)
		if(!this.state.showActiveCheckbox){
			let search_string = event.target.value;
			if (search_string === "") {
				let reason_breach = this.state.reasonforBreachActiveArrayAll;            
				this.setState({show_reason_for_breach_array: reason_breach});
			}else {
				let all_value = this.state.reasonforBreachActiveArrayAll;
				let filtered_values = [];
				all_value.forEach((breach) => {
					if (breach.reasonforBreachName.toLowerCase().includes(search_string.toLowerCase())) {
						filtered_values.push(breach);
					}                
				})            
				let reason_breach = filtered_values;

				this.setState({show_reason_for_breach_array: reason_breach})
			}
		}else{
			let search_string = event.target.value;
			if (search_string === "") {
				let reason_breach = this.state.reasonforBreachInactiveArrayAll;            
				this.setState({show_reason_for_breach_array: reason_breach});
			}else {
				let all_value = this.state.reasonforBreachInactiveArrayAll;
				let filtered_values = [];
				all_value.forEach((breach) => {
					if (breach.reasonforBreachName.toLowerCase().includes(search_string.toLowerCase())) {
						filtered_values.push(breach);
					}                
				})            
				let reason_breach = filtered_values;

				this.setState({show_reason_for_breach_array: reason_breach})
			}
		}
    }
    
    handleActiveInactive = (value) => (event) => {        
        console.log("value",value)  
		let data = value === 1 ? true : false;
		this.props.changeActiveInactive(data);		       
    }

    showConfigModal = (curid, isdelete) => (obj) => {
		console.log("curid==>", curid)
		console.log("obj==>", obj)
		if(obj === 'Edit'){
			const content = this.state.reason_for_breach.find((item) => {
                return item.reasonforBreachID === curid;
            })
            this.setState({content,curid: curid,show_reason_for_breach_modal: true, headerText: "Edit"}); 
		}else if(obj === 'Delete'){
            if(isdelete === 0){
                let alert_param = {title: 'Warning', message: 'Are you sure you want to delete this Root Cause from the list?', ok_text: 'Yes', cancel_text: 'No', confirm: true, 
                           alertHandler: this.updatedeleteReasonBreach, stack: {id: curid}}
                this.setState({alert_param: alert_param})
            }else{
                let alert_param = {title: 'ERROR', message: 'This Root Cause has already been used.', ok_text: 'Ok', confirm: false, 
                           alertHandler: this.updateafternodelete, stack: {}}
                this.setState({alert_param: alert_param})
            }			
		}
	};

    handlenaSectionIncluded = (section_id) => (event) => {
		console.log("content:", section_id);
		let {show_reason_for_breach_array} = this.state;
		let newreason_for_breach = [];
		show_reason_for_breach_array.forEach((item) => {
			if (item.reasonforBreachID === section_id) {
				item.isActive = item.isActive === 1 ? 0 : 1; 
				//console.log("matched", item);
			}
			newreason_for_breach.push(item);
		})
		console.log("emails:", newreason_for_breach);
        this.setState({isLoadedIcon: true})
		this.props.updatereason_for_breach(newreason_for_breach);
	}

    tableData = () => {
        //console.log("this.state.show_reason_for_breach_array",this.state.show_reason_for_breach_array)
        let ret = {data: [], columns: []};
        ret.columns =[
                        {Header: 'Name', accessor: 'name', minWidth: 240, headerStyle: {textAlign: 'left'}},					
						// {Header: 'Status', accessor: 'status', minWidth: 80, headerStyle: {textAlign: 'center'}, style: {textAlign: 'center'}},
                        {'Header' : 'Status', Cell: row => (
							<div> 
							<Toggle
								style={{float:'left'}}
								defaultChecked={row.original.status === "Active" ? true : false}
								icons={false}	
                                onChange={this.handlenaSectionIncluded(row.original.id)}						
							/>
							</div>
						 ), headerStyle:{textAlign: 'center'},style: {textAlign: 'center'}},						
                        {'Header' : '', Cell: row => (
                            <div>                                
                                  <VerticalEllipsisMenuFolderReasonBreach editDelete={this.showConfigModal(row.original.id, row.original.isdelete)} options={["Edit", "Delete"]} />	
                            </div>
                         ), minWidth: 40, headerStyle:{textAlign: 'left'},style: {textAlign: 'center'}}
                        ];

        let reason_for_breach_sort_array = this.state.show_reason_for_breach_array.sort(function(a,b) {return (a.reasonforBreachName > b.reasonforBreachName) ? 1 : ((b.reasonforBreachName > a.reasonforBreachName) ? -1 : 0);} );
		reason_for_breach_sort_array.forEach((item) => {
			let statusValue = item.isActive === 1 ? "Active" : "Inactive"
			let elem = {id: item.reasonforBreachID, name: item.reasonforBreachName, status: statusValue, isdelete: item.isDelete};
			ret.data.push(elem);
        })
        return ret;
    }

    notDeleteReasonBreach = () => {
        //alert("This Reason for Breach has already been used.")
        let alert_param = {title: 'ERROR', message: 'This Reason for Breach has already been used.', ok_text: 'Ok', confirm: false, 
                           alertHandler: this.updateafternodelete, stack: {}}

        this.setState({alert_param: alert_param})
    }

    updateafternodelete = (result, stack) => {
        console.log(result,stack)
        this.setState({alert_param: null})        
    }

    deleteReasonBreach = (id) => (event) => {
        event.preventDefault(); 
        let alert_param = {title: 'Warning', message: 'Are you sure you want to delete this Root Cause from the list?', ok_text: 'Yes', cancel_text: 'No', confirm: true, 
                           alertHandler: this.updatedeleteReasonBreach, stack: {id: id}}
        this.setState({alert_param: alert_param})
        // if (window.confirm('Are you sure you want to delete this Reason for Breach from the list?')) {
        //    	console.log("id",id)
        //    	let {reason_for_breach} = this.state;
		// 	let newreason = [];
		// 	for(let i=0;i<this.state.reason_for_breach.length;i++)
		// 	{
		// 		if(this.state.reason_for_breach[i].reasonforBreachID !== id){
		// 			newreason.push(this.state.reason_for_breach[i])
		// 		}
		// 	}			 
		// 	console.log("delete===>",newreason);   
		// 	this.props.deleteReasonForBreachValue(newreason);        
		// }         		  
    }

    updatedeleteReasonBreach = (result, stack) => {        
        
        if(!result) {
            this.setState({alert_param: null})
            return
        }
        console.log("id",stack.id)
        let {reason_for_breach} = this.state;
        let newreason = [];
        for(let i=0;i<this.state.reason_for_breach.length;i++)
        {
            if(this.state.reason_for_breach[i].reasonforBreachID !== stack.id){
                newreason.push(this.state.reason_for_breach[i])
            }
        }			 
        console.log("delete===>",newreason);   
        this.props.deleteReasonForBreachValue(newreason);
           
    }

    openModal = (id) => (event) => {
		event.preventDefault();     
		console.log("id",id); 
		const content = this.state.reason_for_breach.find((item) => {
			return item.reasonforBreachID === id;
		})
		this.setState({content,curid: id,show_reason_for_breach_modal: true});        
	}
    
    addReasonForBreach = (event) => {
		event.preventDefault();
		this.setState({show_reason_for_breach_modal: true,curid: 0, headerText: "Add"})
    }
    closeModal = () => {		
		this.setState({show_reason_for_breach_modal: false})
    }
    
    saveReasonForBreachValue = (obj) => {
		this.setState({show_reason_for_breach_modal: false, isLoadedIcon: true})
		this.props.saveReasonForBreachValue(obj)
    }
    
    importType = (event) => {
        event.preventDefault();
        console.log("standard_reason_for_breach",this.state.standard_reason_for_breach)
        let alert_param = {title: 'Warning', message: 'Are you sure you want to import the reason for breach?', ok_text: 'Yes', cancel_text: 'No', confirm: true, 
                           alertHandler: this.updateimportTypeBreach, stack: {}}
        this.setState({alert_param: alert_param})

        // if (window.confirm('Are you sure you want to import the reason for breach?')) {
        //     let show_reason_for_breach_array = this.state.reason_for_breach;
        //     this.state.standard_reason_for_breach.forEach((breach) => {
        //         show_reason_for_breach_array.push(breach);               
        //     })
        //     this.props.importResonForBreachValue(show_reason_for_breach_array)            
        // }
    }

    updateimportTypeBreach = (result, stack) => {       
        if(!result) {
            this.setState({alert_param: null})
            return
        }       
        let show_reason_for_breach_array = this.state.reason_for_breach;
        this.state.standard_reason_for_breach.forEach((breach) => {
            show_reason_for_breach_array.push(breach);               
        })
        this.props.importResonForBreachValue(show_reason_for_breach_array)  
    }

    updateReasonForBreachValue = (content) => {
		console.log("content:", content);
		//console.log("this.state",this.state.reason_for_removal)
		let {reason_for_breach} = this.state;
		let newreason = [];
		reason_for_breach.forEach((item) => {
			if (item.reasonforBreachID === content.reasonforBreachID) {
				item = content;
				console.log("matched", item);
			}
			newreason.push(item);
		})
		console.log("resons:", newreason);
		this.setState({show_reason_for_breach_modal: false, isLoadedIcon: true})
		this.props.updateReasonForBreachValue(newreason);		
	}
    
    
    render()    
	{
        if (!this.state.ready) {
			return (<div>Loading...</div>);
		}          
		return(
        <div>            
            <div>
                    {
                        (() => {
                            if (this.state.show_reason_for_breach_modal) {
                                return (<div ><InactiveOverlay style={{height: "105%"}}/><ReasonForBreachConfigModal headerText={this.state.headerText} closeModal={this.closeModal} curid={this.state.curid} content={JSON.parse(JSON.stringify(this.state.content))} updateReasonForBreachValue={this.updateReasonForBreachValue} saveReasonForBreachValue={this.saveReasonForBreachValue}/></div>);
                            }
                        })()
                    }
                    {
                        (() => {
                            if(this.state.isLoadedIcon){
                                return <div><CSLLoader style={{position: 'absolute'}}/></div>
                            }
                        })()
                    }                    
                    <EmailContainer>
                        <EmailInnerContainer>                            
                            <EmailTopHeader style={{display: "inline-block" , fontWeight: 700}}>
                                Root Cause
                                <div style={{float:'right'}}>
                                    <div onClick={this.addReasonForBreach}  style={{float: "left", cursor: "pointer",fontSize: "25px",color: "#04ADA8"}}>
                                        <FaPlusCircle  /> 
                                    </div>
                            
                                    <div style={{float: "right", cursor: "pointer",fontSize: "25px",color: "#e4e4e4"}}>
                                        <FaEllipsisV  /> 
                                        </div>
                                </div>
							</EmailTopHeader>
                            <CSLTable add={false} processData={this.tableData} tableRows={10} />
                        </EmailInnerContainer>
                    </EmailContainer>
            </div>
            <AlertBox alertParam = {this.state.alert_param}/>
        </div>
        );
	}
}

export default ReasonForBreach;